export default __webpack_public_path__ + "static/media/bm-flag.b2e0a8be.svg";